export default "__VITE_ASSET__24920ecc__"